var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMitten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59099 14.1814L9.81904 21.4091C10.607 22.197 11.8845 22.197 12.6724 21.409L13.5119 20.5695C13.4975 20.5571 13.4834 20.544 13.4697 20.5303L3.42909 10.4898L2.59096 11.3279C1.803 12.1159 1.80302 13.3934 2.59099 14.1814Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.93934V4.5C4 3.11929 5.11929 2 6.5 2C7.88071 2 9 3.11929 9 4.5V4.91879L9.83087 4.08791C12.6147 1.30403 17.1283 1.30403 19.9121 4.08791C22.696 6.8718 22.696 11.3854 19.9121 14.1693L14.5695 19.5119C14.5571 19.4975 14.544 19.4834 14.5303 19.4697L4 8.93934Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitten);
export default __webpack_public_path__ + "static/media/mitten.5a2f081956c16a5ee51a20eee9d26b81.svg";
export { ForwardRef as ReactComponent };